/* import __COLOCATED_TEMPLATE__ from './issue-list-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();